/* eslint-disable */

export const getLocalDisplayNumber = (machine = {}) => {
  const raw =
    machine?.LocalDisplayNumber ??
    machine?.localDisplayNumber ??
    machine?.Machine?.LocalDisplayNumber ??
    machine?.Machine?.localDisplayNumber ??
    machine?.LocalMachine?.LocalDisplayNumber ??
    machine?.LocalMachine?.localDisplayNumber ??
    null;

  if (raw === null || raw === undefined || raw === "") return null;
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
};

export const getMachineBaseName = (machine = {}, fallback = "Máquina sin nombre") => {
  const raw =
    machine?.Machine?.Name ??
    machine?.Machine?.name ??
    machine?.MachineName ??
    machine?.machineName ??
    machine?.Name ??
    machine?.name ??
    null;
  const name = String(raw ?? "").trim();
  return name || fallback;
};

export const buildMachineDisplayName = (machine = {}, options = {}) => {
  const {
    fallback = "Máquina sin nombre",
    compact = false,
  } = options;
  const name = getMachineBaseName(machine, fallback);
  const localDisplayNumber = getLocalDisplayNumber(machine);

  if (!localDisplayNumber) return name;
  return compact ? `#${localDisplayNumber} ${name}` : `Nº ${localDisplayNumber} - ${name}`;
};
